"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIND_REFS = exports.SUBS_NAMESPACE = exports.COMPACT_NAMESPACE = exports.INDEX_NAMESPACE = exports.createReferencesResolver = void 0;
var Util_1 = require("./Util");
var createReferencesResolver = function (localsOnly) { return new ReferencesResolverImpl(localsOnly ? true : false); };
exports.createReferencesResolver = createReferencesResolver;
exports.INDEX_NAMESPACE = '/index';
exports.COMPACT_NAMESPACE = '/compact';
exports.SUBS_NAMESPACE = '/subs';
exports.FIND_REFS = new RegExp(/%?%[\w-./@]+%?/gm);
var ReferencesResolverImpl = (function () {
    function ReferencesResolverImpl(localsOnly) {
        this.localsOnly = localsOnly;
    }
    ReferencesResolverImpl.prototype.resolve = function (referenceObject, dataObject) {
        if (dataObject === null || dataObject === undefined) {
            throw new Error('Cannot dereference an undefined dataObject.');
        }
        if (typeof dataObject === 'string') {
            return this.processString(referenceObject, dataObject);
        }
        var index = Array.isArray(dataObject['?']) ? dataObject['?'] : [dataObject['?']];
        if (index) {
            index.forEach(function (v, i) {
                referenceObject.set("" + i, v);
            });
        }
        return Array.isArray(dataObject) ? this.processArray('', referenceObject, dataObject) : this.processObject('', referenceObject, dataObject);
    };
    ReferencesResolverImpl.prototype.processArray = function (parent, referenceValues, arr) {
        var _this = this;
        var result = [];
        arr.forEach(function (value, index) {
            var newParent = parent + "." + index;
            if (Array.isArray(value)) {
                result.push(_this.processArray(newParent, referenceValues, value));
            }
            else if (typeof value === 'object') {
                result.push(_this.processObject(newParent, referenceValues, value));
            }
            else if (typeof value === 'string') {
                result.push(_this.processString(referenceValues, value));
            }
            else {
                result.push(value);
            }
        });
        return result;
    };
    ReferencesResolverImpl.prototype.processObject = function (parent, referenceValues, obj) {
        var _this = this;
        if (obj === null) {
            return null;
        }
        var result = {};
        Object.keys(obj).forEach(function (k) {
            var value = obj[k];
            if (value === null) {
                result[k] = null;
                return;
            }
            var newParent = parent + "." + k;
            if (Array.isArray(value)) {
                result[k] = _this.processArray(newParent, referenceValues, value);
            }
            else if (typeof value === 'object') {
                result[k] = _this.processObject(newParent, referenceValues, value);
            }
            else if (typeof value === 'string') {
                result[k] = _this.processString(referenceValues, value);
            }
            else {
                result[k] = value;
            }
        });
        return result;
    };
    ReferencesResolverImpl.prototype.processString = function (referenceValues, str) {
        var _this = this;
        var result = str;
        var refsInString = [];
        var matches = exports.FIND_REFS.exec(result);
        while (matches !== null) {
            var ref = matches[0];
            refsInString.push(ref);
            matches = exports.FIND_REFS.exec(result);
        }
        refsInString.forEach(function (ref) {
            if (ref.startsWith('%%')) {
                return;
            }
            var bareRef = ref.startsWith('%') && ref.endsWith('%') ? ref.substring(1, ref.length - 1) : ref.substring(1);
            if (Util_1.isNumeric.test(bareRef)) {
                bareRef = "/index." + bareRef;
            }
            var replacement = referenceValues.get(bareRef);
            if (replacement !== null && replacement !== undefined && typeof result === 'string') {
                if (result === ref) {
                    if (typeof replacement === 'string' && !_this.localsOnly) {
                        result = _this.unref(replacement);
                    }
                    else {
                        result = replacement;
                    }
                }
                else {
                    if (typeof replacement === 'object') {
                        var rawRef = _this.unref(ref);
                        console.error(rawRef + " refers to an object or array and cannot be embedded in a string");
                        result = result.replace(ref, "" + rawRef);
                    }
                    else {
                        result = result.replace(ref, "" + replacement);
                    }
                }
            }
            else if (result === ref) {
                result = null;
            }
            else {
                result = result.replace(ref, '');
            }
        });
        if (typeof result === 'string') {
            return result.replace('%%', '%');
        }
        if (result === null && this.localsOnly) {
            return str;
        }
        return result;
    };
    ReferencesResolverImpl.prototype.unref = function (ref) {
        return ref.replace('/index.', '').replace('/subs.', '');
    };
    return ReferencesResolverImpl;
}());
//# sourceMappingURL=ReferencesResolver.js.map